






















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class PdfDisplayDialog extends BaseComponent {
  @Prop()
  url: string;

  @Prop()
  urlDownload: string;

  @Prop({ default: 'PDF' })
  title: string;

  @Prop({ default: 'PDF' })
  filename: string;

  dialogFlag = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.dialogFlag = true;
  }

  @Watch('url', { immediate: true })
  onWatchUrl(url) {
    if (!url) {
      return;
    }

    setTimeout(() => {
      this.loadIframeContent();
    }, 500);
  }

  loadIframeContent() {
    this.loader.start('Aguarde ...');
    let iframe = this.$refs['iframePdf'];
    iframe.src = '/pdfjs/web/viewer.html?file=' + this.url;
    //iframe.src = '/pdfjs/web/viewer.html';
    //iframe.src = 'https://mozilla.github.io/pdf.js/legacy/web/viewer.html?file=' + this.url;
    //iframe.src = 'https://mozilla.github.io/pdf.js/web/viewer.html?file=' + this.url;
    setTimeout(() => {
      this.loader.stop();
    }, 5000);
  }

  async download() {
    this.loader.start('Aguarde ...');
    setTimeout(() => {
      this.downloadLink(this.urlDownload, this.filename, null);      
    }, 200);
    setTimeout(() => {
      this.loader.stop();
    }, 5000);
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }
}
